exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".inverted .ta.sharing .share:not(.inverted),.inverted .ta.sharing:not(.inverted) .share{color:#007abf}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/@ta-interaktiv/react-share-buttons/style/styles.css
// module id = 74
// module chunks = 0